module.exports = __webpack_public_path__ + "img/2.01840079.jpg";